module.exports = __webpack_public_path__ + "media/images/menu_Itemsecret_collection-9d2c209ae0cf5dfc00461103c42c0c18.png";